<template>
  <base-input label="Reports" sr-only-label label-for="view" placeholder="Reports">
    <el-select @change="toggle" v-model="view" placeholder="Select a Report">
      <el-option v-for="(option, index) in options"
                 :key="index"
                 :label="option.text"
                 :value="option.value">
      </el-option>
    </el-select>
  </base-input>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    fields: null,
    report_type: null
  },
  data() {
    return {
      view: ['agents', 'listings_taken', 'listings_taken_volume', 'listings_taken_gci'],
      options:[
        { value: ['agents', 'listings_taken', 'listings_taken_volume', 'listings_taken_gci'], text: 'Listings Taken Report' },
        { value: ['agents', 'listings_sold', 'listings_sold_volume', 'listings_sold_gci', 'buyers_sold', 'buyers_sold_volume', 'buyers_sold_gci', 'total_sales', 'total_sales_volume', 'total_sales_gci'], text: 'Sales Report' },
        { value: ['agents', 'listings_closed', 'listings_closed_volume', 'listings_closed_gci', 'buyers_closed', 'buyers_closed_volume', 'buyers_closed_gci', 'total_closed', 'total_closed_volume', 'total_closed_gci'], text: 'Closings Report' },
      ]
    }
  },
  methods: {
    toggle() {
      this.fields.filter((field) => {
        field.visible = false
      });

      this.view.forEach((value) => {
        this.fields.filter((field) => {
          if(field.key == value) {
            field.visible = !field.visible;
          }
        });
      });

      let view = 'listings';

      if (this.view == this.options[0].value) {
        this.$emit('updateView', 'listings');
      } else if (this.view == this.options[1].value) {
        this.$emit('updateView', 'sales');
      } else {
        this.$emit('updateView', 'closings');
      }
    },
  }
};
</script>